module.exports = __webpack_public_path__ + "img/ico-pressure-high-n.5531dff9.png";